import Cookies from 'universal-cookie';

import {MFA_PENDING_COOKIE, MFA_COOKIE_OPTIONS} from "../../config/MfaConfig";

const cookies = new Cookies();

// Rehydrate on boot so a refresh on the enrolment/challenge screen resumes
// rather than dumping the user back at the password prompt. Holds nothing
// sensitive - see MFA_PENDING_COOKIE.
const storedPending = cookies.get(MFA_PENDING_COOKIE);
// console.log('Loaded cookie of mfa_pending: ', storedPending);

// Only the three fields the login response exposed, and only when the server
// actually flagged MFA. Anything else in the cookie is ignored.
const rehydratedPending = (storedPending && storedPending.mfa_required)
  ? {
    mfa_required: true,
    mfa_enrolled: !!storedPending.mfa_enrolled,
    user_type: storedPending.user_type || ''
  }
  : null;

const initialState = {
  // Null when there is no pending MFA session (i.e. not mid-flow).
  pending: rehydratedPending
};

export default function mfaReducer(state = initialState, action) {

  switch (action.type) {

    case 'MFA_PENDING':
    {
      const data = action.payload || {};
      const pending = {
        mfa_required: true,
        mfa_enrolled: !!data.mfa_enrolled,
        user_type: data.user_type || ''
      };
      cookies.set(MFA_PENDING_COOKIE, pending, MFA_COOKIE_OPTIONS);
      return {
        ...state,
        pending: pending
      };
    }

    case 'MFA_CLEAR':
    // falls through - explicit abandon: pending MFA session dropped, back to signed out.
    case 'LOGIN_USER':
    // falls through - MFA stage 2 returned the full login payload, so the flow is complete.
    case 'LOGOUT_USER':
    {
      cookies.remove(MFA_PENDING_COOKIE, MFA_COOKIE_OPTIONS);
      return {
        ...state,
        pending: null
      };
    }

    case 'MFA_ENROLLED':
    {
      if (!state.pending) return state;
      const pending = {
        ...state.pending,
        mfa_enrolled: true
      };
      cookies.set(MFA_PENDING_COOKIE, pending, MFA_COOKIE_OPTIONS);
      return {
        ...state,
        pending: pending
      };
    }

    case 'MFA_UNENROLLED':
    {
      if (!state.pending) return state;
      const pending = {
        ...state.pending,
        mfa_enrolled: false
      };
      cookies.set(MFA_PENDING_COOKIE, pending, MFA_COOKIE_OPTIONS);
      return {
        ...state,
        pending: pending
      };
    }

    default:
      return state;
  }
}